import React, { useState } from 'react';
import { TabsAlignment, Flex, FlexBehavior, FlexDirection, FlexWrap, FlexAlignItems } from 'react-magma-dom';

import { Navbar } from '../Navbar';
import { Logo } from '../Logo';
import { MAIN_NAV_LIST } from '../../constants';
import { StyledHeader, StyledAccountButton, StyledNavWrapper } from '../Styled';
import { useLocation } from '@reach/router';
import { BurgerMenuButton } from '../Button';
import { SideNavigation } from '../SideNavigation';
import { DropDownMenu } from '../DropDownMenu';

export const Header = (): JSX.Element => {
  const location = useLocation();
  let current = location.pathname.split('/')[1];
  if (!MAIN_NAV_LIST.includes(current)) {
    current = MAIN_NAV_LIST[0];
  }

  const [showMenu, setShowMenu] = useState(false);

  const handleBurgerMenuClick = () => {
    setShowMenu(!showMenu);
  };

  return (
    <StyledHeader>
      <Logo />
      <StyledNavWrapper>
        <Navbar
          ariaLabel="main navigation"
          navLinks={MAIN_NAV_LIST}
          tabsAlignment={TabsAlignment.center}
          current={current}
        />
      </StyledNavWrapper>
      <div>
        <Flex
          alignItems={FlexAlignItems.center}
          behavior={FlexBehavior.container}
          direction={FlexDirection.row}
          wrap={FlexWrap.nowrap}
        >
          <StyledAccountButton>
            <DropDownMenu />
          </StyledAccountButton>
          <BurgerMenuButton handleClick={handleBurgerMenuClick} />
        </Flex>
      </div>
      {showMenu && <SideNavigation current={current} handleOutsideClick={handleBurgerMenuClick} />}
    </StyledHeader>
  );
};
